<template>
  <div id="trivia">
    <section class="bannerprincipal">
      <SiteNav v-if="showNav"></SiteNav>
      <div
        v-if="!showNav"
        class="col-12 text-center"
        data-aos="fade-down"
        data-aos-delay="100"
      >
        <!-- <router-link to="/">
          <img
            class="pt-5 img-fluid"
            src="../assets/imgs/homecapistrano/texto-1.png"
            alt="Copa Prosa"
          />
        </router-link> -->
      </div>

      <div class=""></div>
    </section>

    <section class="pt-5 mt-5">
      <div class="container pt-2 mt-5">
        <div class="row pt-5">
          <div class="col-12">
            <p>
              Para Promoción y Operación S.A. de C.V. (PROSA) es muy importante
              mantener la privacidad y confianza de sus Clientes, con el
              propósito de asegurar que se conozca cómo salvaguardamos la
              integridad, privacidad y protección de sus datos personales, le
              damos a conocer el aviso de privacidad integral para Clientes, en
              apego a la Ley Federal de Protección de Datos Personales en
              Posesión de los Particulares (en adelante referida como “la Ley”)
              y su Reglamento, por lo que solicitamos lea atentamente la
              siguiente información:
            </p>
            <p>1.- IDENTIDAD Y DOMICILIO DEL RESPONSABLE</p>
            <p>
              Promoción y Operación S.A. de C.V. (en adelante “El Responsable”)
              declara ser una empresa legalmente constituida de conformidad con
              las leyes mexicanas, con domicilio el ubicado en Bahía de
              Chachalacas #7, Colonia Verónica Anzures, Alcaldía de Miguel
              Hidalgo, C.P. 11300, Ciudad de México.
            </p>
            <p>
              Para solicitudes e información, se cuenta con un servicio de
              atención, en el número telefónico
            </p>
            <p>
              55 5268-1514 en un horario de 9:00 a 18:00 hrs. de lunes a
              viernes, así como el correo electrónico&nbsp;<a
                href="mailto:asc@prosa.com.mx"
                >asc@prosa.com.mx</a
              >
            </p>
            <p>
              Nuestro aviso de privacidad integral para Clientes se podrá
              consultar en el portal de internet:
              <a
                href="https://www.prosa.com.mx"
                target="_blank"
                rel="noopener noreferrer"
                >https://www.prosa.com.mx</a
              >,
              <a
                href="https://www.carnet.mx"
                target="_blank"
                rel="noopener noreferrer"
                >https://www.carnet.mx</a
              >,<a
                href="https://www.promocionesmsi.com.mx"
                target="_blank"
                rel="noopener noreferrer"
                >https://www.promocionesmsi.com.mx</a
              >,
              <a
                href="https://www.academiaprosa.com"
                target="_blank"
                rel="noopener noreferrer"
                >https://www.academiaprosa.com</a
              >
              y<a
                href="https://prosaanalytics.com"
                target="_blank"
                rel="noopener noreferrer"
                >https://prosaanalytics.com</a
              >
            </p>
            <p>2.- DATOS PERSONALES SOMETIDOS A TRATAMIENTO</p>
            <p>
              El Responsable podrá recabar sus datos personales de manera
              directa o indirecta mediante el uso de medios remotos de
              comunicación electrónica, óptica u otra tecnología que permitan
              recabar sus datos personales de manera automática y simultánea.
              Para el cumplimiento y consecución de las finalidades por las que
              se obtienen y se recaban los datos personales, se le informa que
              se podrán recabar todas o algunas de las siguientes categorías de
              datos personales:
            </p>
            <div><p>i. Datos de identificación;</p></div>
            <div><p>ii. Datos laborales;</p></div>
            <div><p>iii. Datos de contacto;</p></div>
            <div><p>iv. Datos profesionales (académicos);</p></div>
            <div><p>v. Datos migratorios; y</p></div>
            <div><p>vi. Datos patrimoniales y/o financieros.</p></div>
            <p>3.- DATOS SENSIBLES</p>
            <p>
              Se le informa que El Responsable no recabará datos personales
              sensibles, se consideran “datos sensibles” aquellos datos
              personales que afecten a la esfera más íntima de la persona
              titular, o cuya utilización indebida pueda dar origen a
              discriminación o conlleve un riesgo grave para esta. De manera
              enunciativa más no limitativa se consideran sensibles los datos
              personales que puedan revelar aspectos como origen racial o
              étnico, estado de salud presente o futuro, información genética,
              creencias religiosas, filosóficas y morales, opiniones políticas y
              preferencia sexual.
            </p>
            <p>4.- FINALIDADES DEL TRATAMIENTO DE DATOS PERSONALES</p>
            <p>FINALIDADES PRIMARIAS</p>
            <p>
              El Responsable tratará sus datos personales para las siguientes
              finalidades primarias, que requieren el consentimiento de la
              persona titular (las cuáles dan origen a la relación contractual y
              son necesarias para la existencia, mantenimiento y cumplimiento de
              la relación jurídica entre El Responsable y la persona titular de
              los datos personales), por lo que el titular autoriza a El
              Responsable utilizar sus datos personales para las siguientes
              finalidades Primarias:
            </p>
            <ul>
              <li>
                Administrar y operar los servicios y/o productos que solicita o
                contrata la persona titular con El Responsable. • Consultas,
                investigaciones y/o revisiones, para atender cualquier queja,
                reclamación o aclaración que se reciba por parte de la persona
                titular. • Dar cumplimiento a las obligaciones contractuales
                contraídas por la persona titular con El Responsable y en su
                caso con sus subsidiarias. • Formalizar y registrar la
                contratación de un producto y/o servicio. • Identificación y
                conocimiento de la persona titular cuando actúan con el carácter
                de clientes, validación de su identidad y registro de sus datos
                para efectos de identificación del producto y/o servicio
                contratado con El Responsable. • Informar a la persona titular
                que actúa con el carácter de cliente, sobre cambios en los
                productos y/o servicios contratados con El Responsable. •
                Notificaciones sobre cambios en condiciones de uso de los
                productos y/o servicios contratados por la persona titular. •
                Operación y registro de los productos y/o servicios contratados
                por la persona titular. • Integración y actualización de
                expedientes de identificación del cliente, como pueden ser
                programas de conoce a tu cliente o prevención de lavado de
                dinero • Atención de requerimientos de cualquier autoridad
                competente conforme a la legislación aplicable a las entidades
                financieras.
              </li>
            </ul>
            <p>
              Al término de la relación contractual, los datos personales
              recabados se utilizarán y resguardarán para los fines exclusivos
              establecidos en las Leyes aplicables.
            </p>
            <p>FINALIDADES SECUNDARIAS</p>
            <p>
              Asimismo, si no se manifiesta lo contrario, El Responsable tratará
              sus datos personales para las siguientes finalidades secundarias:
            </p>
            <p>
              *Realizar estudios de mercado. *Información estadística referente
              al uso de los productos y/o servicios contratados por la persona
              titular. *Informar sobre nuevos productos y/o servicios que estén
              relacionados con lo contratado o adquirido por la persona titular.
            </p>
            <p>
              5.- MECANISMOS PARA QUE PUEDA MANISFESTAR SU NEGATIVA PREVIA AL
              TRATAMIENTO DE LOS DATOS PERSONALES.
            </p>
            <p>
              En caso de que el aviso de privacidad no sea dado a conocer a la
              persona titular de manera directa o personal, esta podrá
              manifestar su oposición en el tratamiento de sus datos personales
              para finalidades que no son necesarias, ni dieron origen a la
              relación jurídica o contractual entre El Responsable y la persona
              titular, conforme al procedimiento para ejercer los derechos ARCO
              señalado en el presente aviso de privacidad.
            </p>
            <p>6.- TRANSFERENCIA DE DATOS PERSONALES</p>
            <p>
              Con el propósito de dar cumplimiento a las obligaciones derivadas
              de la relación jurídica, El Responsable requiere transferir sus
              datos personales, al interior y fuera del territorio nacional, así
              como también, se compromete a velar por que se cumplan todos los
              principios legales de protección de datos personales derivados de
              la transferencia de sus datos personales y asegurar el
              cumplimiento en todo momento del presente aviso de privacidad.
            </p>
            <p>
              Por lo que El Responsable podrá transferir, comunicar y/o tratar
              los datos personales de la persona titular dentro y fuera del
              país, a terceros como son: 1) Sociedad subsidiarias, afiliadas o
              que formen parte del mismo grupo de El Responsable, 2)
              Reguladores, 3) Patrocinadores, socios comerciales o de negocio
              que ofrezcan productos o que presten algún servicio a El
              Responsable.
            </p>
            <p>
              Adicionalmente El Responsable podrá transferir los datos
              personales de la persona titular, si alguna Ley así lo exige, o
              bien, cuando así lo soliciten autoridades competentes en términos
              de la legislación aplicable.
            </p>
            <p>
              Sin perjuicio de lo anterior, El Responsable velará por el
              cumplimiento de los principios de protección de datos personales
              establecidos en la Ley, adoptando las medidas necesarias para su
              aplicación, así como a exigir su cumplimiento a las personas
              físicas o morales a los que se lleguen a transferir los datos
              personales cuya finalidad prevista para la transferencia de sus
              datos personales son motivadas para el cumplimiento de la relación
              jurídica entre El Responsable y la persona titular.
            </p>
            <p>7.- CONSENTIMIENTO PARA LA TRANSFERENCIA DE DATOS PERSONALES.</p>
            <p>
              Con la aceptación del presente aviso de privacidad, la persona
              titular otorga su consentimiento y aceptación para que El
              Responsable transfiera sus datos personales a terceros nacionales
              o extranjeros conforme a lo previsto en el numeral seis del
              presente aviso de privacidad.
            </p>
            <p>
              8.- MEDIOS PARA EJERCER LOS DERECHOS ARCO (ACCESO, RECTIFICACIÓN,
              CANCELACIÓN U OPOSICIÓN).
            </p>
            <p>
              Tiene derecho a conocer qué datos personales tenemos, para qué los
              utilizamos y las condiciones del uso que les damos (“Acceso”).
              Asimismo, es su derecho solicitar la corrección de su información
              personal en caso de que esté desactualizada, sea inexacta o
              incompleta (“Rectificación”); que eliminemos de nuestros registros
              o bases de datos cuando considere que la misma no está siendo
              utilizada adecuadamente (“Cancelación”); así como oponerse al uso
              de sus datos personales para fines específicos (“Oposición”).
              Estos derechos se conocen como Derechos ARCO.
            </p>
            <p>
              Para el ejercicio de cualquiera de los Derechos ARCO, deberá
              seguir el siguiente procedimiento y reunir los requisitos
              mencionados:
            </p>
            <ol>
              <li>
                El procedimiento inicia con la petición del “formato” de
                solicitud para ejercer el Derecho ARCO, mismo que puede
                solicitar a través de nuestro centro de atención y servicio a
                clientes.
              </li>
              <li>
                El “formato” debidamente llenado y firmado se deberá enviar a la
                dirección de correo&nbsp;<a href="mailto:asc@prosa.com.mx"
                  >asc@prosa.com.mx</a
                >acompañado de la siguiente documentación escaneada, a fin de
                poder realizar una autenticación de la persona titular que desee
                ejercer su Derecho ARCO:
              </li>
            </ol>
            <ul>
              <li>
                Identificación oficial vigente, que puede ser alguna de las
                siguientes, mencionando sin limitar las siguientes:
                <ul>
                  <li>
                    Credencial del Instituto Nacional Electoral, Pasaporte,
                    Cartilla de Servicio Militar Nacional o Cédula Profesional.
                  </li>
                </ul>
                <ul>
                  <li>
                    En los casos en que el ejercicio de los Derechos ARCO se
                    realice a través del representante legal o tutor de la
                    persona titular, además de la acreditación de la identidad
                    de ambos, se deberá entregar el poder notarial
                    correspondiente, carta poder firmada ante dos testigos o
                    declaración en comparecencia de la persona titular.
                  </li>
                </ul>
                <ul>
                  <li>
                    Cuando se quiera ejercer el derecho de rectificación, se
                    tendrá que entregar, además de lo ya indicado, la
                    documentación que acredite el cambio solicitado de acuerdo
                    con los datos personales a rectificar.
                  </li>
                </ul>
              </li>
            </ul>
            <ol>
              <li>
                La respuesta a dicho “formato”, se llevará a cabo por El
                Responsable, durante los siguientes 20 días hábiles contados a
                partir de la fecha en que fue recibido el mismo. Se podrá
                ampliar este plazo en el caso de que la información
                proporcionada en la solicitud sea insuficiente o errónea para
                atenderla, o bien, no se acompañen los documentos a que hacen
                referencia, se requerirá, por una vez y dentro de los 5 días
                hábiles siguientes a la recepción de la solicitud, que aporte
                los elementos o documentos necesarios para dar trámite a la
                misma.
              </li>
            </ol>
            <p>
              La persona titular contará con 10 días hábiles para atender el
              requerimiento, contados a partir del día siguiente en que lo haya
              recibido. De no dar respuesta en dicho plazo, se tendrá por no
              presentada la solicitud correspondiente. En caso de que la persona
              titular atienda el requerimiento de información, el plazo de
              respuesta a la solicitud empezará a correr al día siguiente de que
              la persona titular haya atendido el requerimiento (Es decir, los
              15 días hábiles restantes).
            </p>
            <p>
              En cada etapa del procedimiento la persona titular recibirá un
              acuse de recibo por parte de El Responsable, con la fecha
              correspondiente.
            </p>
            <p>
              <b
                >La resolución adoptada por El Responsable será comunicada a la
                persona titular a través de las opciones elegidas por éste, las
                cuales se deberán indicar en el “formato”.</b
              >
            </p>
            <p>9.- MECANISMOS PARA QUE PUEDA MANIFESTAR SU REVOCACIÓN</p>
            <p>
              En los casos en que la persona titular desee revocar la
              autorización otorgada a El Responsable, respecto de los datos
              personales proporcionados, deberá realizar la solicitud
              correspondiente en los mismos términos establecidos en el presente
              aviso de privacidad para ejercer su Derecho ARCO.
            </p>
            <p>10.- LIMITACIÓN DE USO O DIVULGACIÓN DE LOS DATOS</p>
            <p>
              El Responsable no usa o divulga información para fines distintos a
              los mencionados en el presente aviso de privacidad.
            </p>
            <p>
              Para limitar el uso o divulgación de sus datos personales, El
              Responsable ha instrumentado medidas de seguridad de carácter
              administrativo, físico y técnico con el objeto de evitar un mal
              uso y la divulgación de los datos personales. En cualquier momento
              la persona titular podrá iniciar el procedimiento para limitar el
              tratamiento de sus datos personales, debiendo seguir el
              procedimiento previsto en el numeral ocho del presente aviso de
              privacidad.
            </p>
            <p>
              Adicionalmente, con el objeto de que pueda limitar el uso y
              divulgación de su información personal, lo puede hacer por medio
              de la inscripción en el “Registro Público para Evitar Publicidad”
              (REPEP), que está a cargo de la Procuraduría Federal del
              Consumidor, con la finalidad de que sus datos personales no sean
              utilizados para recibir publicidad o promociones de empresas de
              bienes o servicios.
            </p>
            <p>
              Para más información sobre este registro, puede consultar el
              portal de Internet de la PROFECO, o bien ponerse en contacto
              directo con ésta.
            </p>
            <p>11.- NUESTRO PORTAL DE INTERNET</p>
            <p>
              Los portales de El Responsable se utilizan principalmente para
              cubrir los siguientes propósitos:
            </p>
            <p>
              (i) Facilitar el acceso a los servicios de El Responsable.
              (ii)Publicar y dar a conocer su aviso de privacidad integral.
            </p>
            <p>
              Al acceder a los portales de El Responsable, se establece una
              sesión segura mediante el protocolo SSL (Secure Socket Layer) que
              nos permite que toda la información que viaje desde nuestros
              servidores hacia su terminal y viceversa se mantenga protegida
              contra acceso indebido.
            </p>
            <p>
              Los portales de El Responsable y sus diferentes sitios de internet
              a los que se enlaza se basan en el manejo de Cookies y/o Web
              Beacons que exclusivamente se utilizan para mejorar la experiencia
              de navegación, medir la audiencia y mostrar contenido basado en la
              interacción de la página.
            </p>
            <p>12.- MEDIOS PARA COMUNICAR CAMBIOS AL AVISO DE PRIVACIDAD</p>
            <p>
              Nos reservamos el derecho de efectuar en cualquier momento
              modificaciones o actualizaciones al presente aviso de privacidad,
              para la atención de reformas a la Leyes aplicables, políticas
              internas o nuevos requerimientos para la prestación u ofrecimiento
              de nuestros productos o servicios.
            </p>
            <p>
              Por lo que podrá consultar y estar informado de las
              actualizaciones al aviso de privacidad integral para Clientes,
              ingresando a los portales:<a
                href="https://www.prosa.com.mx"
                target="_blank"
                rel="noopener noreferrer"
                >https://www.prosa.com.mx</a
              >,
              <a
                href="https://www.carnet.mx"
                target="_blank"
                rel="noopener noreferrer"
                >https://www.carnet.mx</a
              >,<a
                href="https://www.promocionesmsi.com.mx"
                target="_blank"
                rel="noopener noreferrer"
                >https://www.promocionesmsi.com.mx</a
              >,
              <a
                href="https://www.academiaprosa.com"
                target="_blank"
                rel="noopener noreferrer"
                >https://www.academiaprosa.com</a
              >
              y<a
                href="https://prosaanalytics.com"
                target="_blank"
                rel="noopener noreferrer"
                >https://prosaanalytics.com</a
              >
            </p>
            <p>
              Fecha de última actualización del presente aviso de privacidad: 30
              de mayo de 2025.
            </p>
          </div>

          <div class="col-12 py-5"></div>
          <div class="col-12 py-5"></div>
        </div>
      </div>
    </section>

    <FooterTerminos></FooterTerminos>
  </div>
</template>

<script>
import SiteNav from "@/components/SiteNavInterior";
import swal from "sweetalert2";

import FooterTerminos from "@/components/FooterTerminos";

export default {
  components: {
    FooterTerminos,
    SiteNav,
  },
  data() {
    return {};
  },
  computed: {
    showNav() {
      //return Object.keys(this.userProfile).length > 1;
      return true;
    },
  },
  mounted: function () {},
};
</script>

<style lang="scss" scoped>
ul {
  li {
    list-style: none;
  }
}
table {
  margin: 0 auto !important;
  border: 1px solid #afafaf;
}
</style>
